import axios from "axios";
import * as types from '../constants/ActionTypes'
import { toast } from 'react-toastify';

// Return Order List Url's
const getReturnOrderListUrl = `${process.env.REACT_APP_API_URL}mobileshop/profile/get-eligible-return-order-list`;

// Return Order List Actions
const returnOrderListRequested = () => ({
    type: types.RETURN_ORDERLIST_REQUEST
  });

const returnOrderListSuccess = data => ({
  type: types.RETURN_ORDERLIST_SUCCESS,
  data
});

const returnOrderListFailure = error => ({
  type: types.RETURN_ORDERLIST_FAILURE,
  error
});


// Return Order Reason List Actions
const returnOrderReasonListRequested = () => ({
  type: types.RETURN_ORDER_REASONREQUEST
});

const returnOrderReasonListSuccess = data => ({
type: types.RETURN_ORDER_REASONSUCCESS,
data
});

const returnOrderReasonListFailure = error => ({
type: types.RETURN_ORDER_REASONFAILURE,
error
});


// Return Order List API
export const getReturnOrderList = (connection_id, mobile) => {
  return dispatch => {
    dispatch(returnOrderListRequested());
    dispatch(returnOrderReasonListRequested());
    axios.get(getReturnOrderListUrl, {
      params: {
        connection_id: connection_id,
        mobile_no: mobile
      },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(returnOrderListSuccess(res.data.results));
          dispatch(returnOrderReasonListSuccess(res.data.results));
        } else if (res.data.ack === "Failure") {
          dispatch(returnOrderListFailure(res.data.status));
          dispatch(returnOrderReasonListFailure(res.data.status));
        } 
      })
      .catch(err => {
          throw err;
      });
  };
};


// Return Order Filter List Action
const returnOrderFilterList = data => ({
  type: types.RETURN_ORDER_FILTERLIST,
  data
});


// Return Order Filter List Data
export const getReturnOrderFilterList = (data) => {
  return dispatch => {
    dispatch(returnOrderFilterList(data))
  }
}

// Return Order Filter List Action
const returnOrderProduct = data => ({
  type: types.RETURN_ORDER_PRODUCT,
  data
});


// Return Order Filter List Data
export const getReturnOrderProduct = (data) => {
  return dispatch => {
    dispatch(returnOrderProduct(data))
  }
}



// Return Order Url's
const getSaveReturnOrderUrl = `${process.env.REACT_APP_API_URL}mobileshop/csaprofile/create-return-order`;

// Return Order List Actions
const saveReturnOrderRequested = () => ({
    type: types.SAVE_RETURN_ORDER_REQUEST
  });

const saveReturnOrderSuccess = data => ({
  type: types.SAVE_RETURN_ORDER_SUCCESS,
  data
});

const saveReturnOrderFailure = error => ({
  type: types.SAVE_RETURN_ORDER_FAILURE,
  error
});

// Save Return Order List
export const saveReturnOrderList = (options) => {
  return dispatch => {
    dispatch(saveReturnOrderRequested());
    axios.post(getSaveReturnOrderUrl, options, {
      headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          //'Content-Type': 'application/json; charset=UTF-8'
        },
    })
      .then(res => {
        if (res.data.ack === "Success") {
          dispatch(saveReturnOrderSuccess(res.data.results));
          toast.error(`Success`);
        } else if (res.data.ack === "Failure") {
          toast.error(`Failed - ${res.data.status.message}`);
          dispatch(saveReturnOrderFailure(res.data.status));
        } 
      })
      .catch(err => {
          throw err;
        // dispatch(addTodoFailure(err.message));
      });
  };
};


const returnOrderInfoClear = () => ({
  type: types.RETURNORDERINFO_CLEAR
});

export const returnOrderClear = (options) => {
  return dispatch => {
    dispatch(returnOrderInfoClear());
  };
};
